export const ANSWER_PREFIX = Array.from(new Array(26), (ele, index) =>
  String.fromCharCode(65 + index)
)

// 主题对应的组件
const moduleCache = new Map() // 添加缓存
const moduleCommonCache = new Map() // 添加缓存

export async function loadSlot(questionType, slots, themeName) {
  const loadModule = async moduleName => {
    // 获取对应 themeName 的缓存子映射
    let themeModuleCache = moduleCache.get(themeName)
    if (!themeModuleCache) {
      themeModuleCache = new Map()
      moduleCache.set(themeName, themeModuleCache)
    }
    if (themeModuleCache.has(moduleName)) {
      return themeModuleCache.get(moduleName) // 从缓存中获取模块
    }

    // 获取对应 themeName 的 common 缓存子映射
    let themeCommonModuleCache = moduleCommonCache.get(themeName)
    if (!themeCommonModuleCache) {
      themeCommonModuleCache = new Map()
      moduleCommonCache.set(themeName, themeCommonModuleCache)
    }
    if (themeCommonModuleCache.has(moduleName)) {
      return themeCommonModuleCache.get(moduleName) // 从缓存中获取模块
    }

    try {
      const module = await import(`./${questionType}/themes/${themeName}/${moduleName}.vue`)
      themeModuleCache.set(moduleName, module.default) // 缓存模块
      return module.default
    } catch {
      // 尝试加载 common 下的模块
      try {
        const module = await import(`../common/${themeName}/${moduleName}.vue`)
        themeCommonModuleCache.set(moduleName, module.default) // 缓存模块
        return module.default
      } catch {
        return undefined
      }
    }
  }

  const slotMap = {}
  for (const key of slots) {
    slotMap[key] = await loadModule(key)
  }
  return slotMap
}

// 根据名称获取插槽
export function getSlot(slotsMap, name) {
  const slots = {}
  for (const key in slotsMap) {
    if (key.includes(name)) {
      const slotName = key.split(`${name}-`)[1]
      slots[slotName] = slotsMap[key]
    }
  }
  return slots
}
